import React from "react";

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import PersonOutlineIcon from "@mui/icons-material/PermIdentity";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import { Box, Typography } from "@mui/material";

const KentaColors = {
  background_light: "#D1DBE3",
  neutral_white: "#FFFFFF",
  neutral_black: "#000000",
};

export type SearchEmptyIcon =
  | "avatar"
  | "record"
  | "file"
  | "magnifier"
  | "video";

export interface SearchEmptyProps {
  textMessage: string;
  typeIcon: SearchEmptyIcon;
  widthHeightBorder?: number;
  widthHeightIcon?: number;
  fontSize?: string;
  marginTop?: string;
  marginBottom?: string;
  marginRight?: string;
  marginLeft?: string;
}

const iconComponentByType: Record<SearchEmptyIcon, React.ElementType> = {
  avatar: PersonOutlineIcon,
  record: VideocamOutlinedIcon,
  file: DescriptionOutlinedIcon,
  magnifier: SearchOutlinedIcon,
  video: OndemandVideoIcon,
};

export const SearchEmpty: React.FC<SearchEmptyProps> = ({
  textMessage,
  typeIcon,
  widthHeightBorder = 108,
  widthHeightIcon = 60,
  fontSize = "16px",
  marginTop,
  marginBottom,
  marginRight,
  marginLeft,
}) => {
  const IconComponent = iconComponentByType[typeIcon];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        marginTop: marginTop ?? 0,
        marginBottom: marginBottom ?? 0,
        marginRight: marginRight ?? 0,
        marginLeft: marginLeft ?? 0,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: widthHeightBorder,
          height: widthHeightBorder,
          borderRadius: "50%",
          backgroundColor: KentaColors.background_light,
        }}
        data-testid="SearchEmpty-Circle"
      >
        <IconComponent
          sx={{
            fontSize: widthHeightIcon,
            color: KentaColors.neutral_white,
          }}
        />
      </Box>
      <Typography
        sx={{
          fontWeight: 600,
          fontSize,
          color: KentaColors.neutral_black,
          mt: 2,
        }}
      >
        {textMessage}
      </Typography>
    </Box>
  );
};

export default SearchEmpty;
